import axios from "axios";

export function axiosPost<T>(url: string, data: any, abortController: AbortController) {
    // NOTE: axios expects `signal` in the 3rd argument (config), not in the body.
    return axios.post<T>(url, data, { signal: abortController.signal });
}
